import { pdStore } from "../store/mini-rx.store.js";
import { selectAuthUser } from "../store/spa-app-selector.js";
//#region src/auth/AuthController.ts
var AuthController = class {
	constructor(host) {
		this.authCheckComplete = false;
		this.host = host;
		host.addController(this);
	}
	hostConnected() {
		this.subscription = pdStore().select(selectAuthUser).subscribe(({ user, loginCheckFinish }) => {
			this.user = user;
			this.authCheckComplete = loginCheckFinish;
			this.host.requestUpdate();
		});
	}
	hostDisconnected() {
		this.subscription?.unsubscribe();
	}
	/** Check if user is logged in */
	get isLoggedIn() {
		return this.user !== void 0;
	}
	/** Anonymous (guest) session? Logged in, but without credentials. */
	get isAnonymous() {
		return this.user?.isAnonymous ?? false;
	}
	/** Get user's email */
	get email() {
		return this.user?.email ?? null;
	}
	/** Get user's UID */
	get uid() {
		return this.user?.uid ?? null;
	}
	/** Get user's claims */
	get claims() {
		return this.user?.claims ?? {};
	}
	/**
	* Check if user has a specific role
	* @param role - The role to check
	*/
	hasRole(role) {
		return this.user?.claims?.[role] === true;
	}
	/**
	* Check if user has at least one of the roles (OR logic)
	* @param roles - Array of roles to check
	*/
	hasAnyRole(roles) {
		if (!this.user?.claims) return false;
		return roles.some((role) => this.user?.claims?.[role] === true);
	}
	/**
	* Check if user has all of the roles (AND logic)
	* @param roles - Array of roles to check
	*/
	hasAllRoles(roles) {
		if (!this.user?.claims) return false;
		return roles.every((role) => this.user?.claims?.[role] === true);
	}
};
//#endregion
export { AuthController };
